import { useEffect, useState } from 'react';
import { useAuth } from '../../../../hooks/useAuth';
import firstImg from '../../assets/first.png';
import secondImg from '../../assets/second.png';
import thirdImg from '../../assets/third.png';
import styles from './KnowledgeTrailOnboarding.module.css';

interface KnowledgeTrailOnboardingProps {
  trailId: string;
  trailTitle: string;
  onClose: () => void;
}

export function KnowledgeTrailOnboarding({
  trailId,
  trailTitle,
  onClose,
}: KnowledgeTrailOnboardingProps) {
  const { player, client } = useAuth();
  const [visible, setVisible] = useState(false);
  const [slideIndex, setSlideIndex] = useState(0);

  const storageKey = `kt-onboarding-${trailId}`;

  useEffect(() => {
    const seen = localStorage.getItem(storageKey);
    if (seen !== 'true') {
      setVisible(true);
    }
  }, [storageKey]);

  if (!visible) return null;

  const playerName = player?.displayName || player?.name || 'Jogador';
  const clientName = client?.companyName || 'a empresa';
  const primaryColor = client?.primaryColor || 'var(--primary)';

  const slides = [
    {
      image: firstImg,
      title: `Olá, ${playerName}!`,
      text: `Vamos começar a Trilha do Conhecimento ${trailTitle} da ${clientName}. Prepare-se para uma jornada incrível de aprendizado!`,
    },
    {
      image: secondImg,
      title: 'Conteúdo Exclusivo',
      text: 'Preparamos um conteúdo especial para você! Para avançar, acesse os materiais e responda todas as perguntas.',
    },
    {
      image: thirdImg,
      title: 'Conquiste sua Certificação',
      text: `Além de aprender um pouco mais sobre a ${clientName}, você ainda vai ganhar uma certificação se completar toda a jornada!`,
    },
  ];

  const isLastSlide = slideIndex === slides.length - 1;

  function handleDismiss() {
    localStorage.setItem(storageKey, 'true');
    setVisible(false);
    onClose();
  }

  function handleNext() {
    if (isLastSlide) {
      handleDismiss();
    } else {
      setSlideIndex(slideIndex + 1);
    }
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        <div className={styles.header}>
          <img src={slides[slideIndex].image} alt={slides[slideIndex].title} />
        </div>

        <div className={styles.content}>
          <h2 className={styles.title}>{slides[slideIndex].title}</h2>
          <p className={styles.text}>{slides[slideIndex].text}</p>
        </div>

        <div className={styles.actions}>
          <button className={styles.btn} onClick={handleDismiss}>
            Pular
          </button>
          <button className={styles.btnCta} onClick={handleNext}>
            {isLastSlide ? 'Começar agora' : 'Próximo'}
          </button>
        </div>

        <div className={styles.dots}>
          {slides.map((_, index) => (
            <div
              key={index}
              className={slideIndex === index ? styles.dotActive : styles.dot}
              style={
                slideIndex === index
                  ? { backgroundColor: primaryColor }
                  : undefined
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
}
